import React from "react";
import App from "./App";
import "./i18next";
import "./index.css"
import { createRoot } from 'react-dom/client';
import './assets/BackOffice/css/bootstrap.min.css';
import './assets/BackOffice/css/icons.min.css';
import './assets/BackOffice/css/app.min.css';
import './assets/FrontOffice/css/bootstrap.min.css';
import './assets/FrontOffice/css/animate.css';
import './assets/FrontOffice/css/font-awesome.css';
import './assets/FrontOffice/css/flaticon.css';
import './assets/FrontOffice/css/themify-icons.css';
import './assets/FrontOffice/css/slick.css';
import './assets/FrontOffice/css/prettyPhoto.css';
import './assets/FrontOffice/css/shortcodes.css';
import './assets/FrontOffice/css/main.css';
import './assets/FrontOffice/css/megamenu.css';
import './assets/FrontOffice/css/responsive.css';
import './assets/FrontOffice/css/product-cart.css';
import './assets/FrontOffice/css/marketplace.css';
import './assets/FrontOffice/css/productdetails.css';
import './assets/FrontOffice/css/salon.css';
import './assets/FrontOffice/css/cartgipp.css';
//import './assets/FrontOffice/css/settings.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const root = createRoot(document.getElementById('root'))
root.render(
  <App />
)